import React from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';

const CafListRow = ({ cafhistory, showresults }) => {
  const validitySetter = (isvalid) => {
    if (isvalid == 1) {
      return (
        <Col md='3' className='white-border'>
          Success
        </Col>
      );
    }
    return (
      <Col md='3' className='white-border errorCol'>
        Failure
      </Col>
    );
  };

  const dateReturner = (date) => {
    if (date == null) {
      return 'No effective date';
    }
    return moment.utc(date).local().format('DD-MM-YYYY');
  };

  if (!cafhistory) return null;

  return (
    <div>
      <Row className='clickerMouse' onClick={() => showresults(cafhistory.id)}>
        <Col md='3' className='white-border'>
          {moment
            .utc(cafhistory.createdOn)
            .local()
            .format('DD-MM-YYYY HH:mm.ss')}
        </Col>
        <Col md='3' className='white-border'>
          {dateReturner(cafhistory.effDate)}
        </Col>
        <Col md='3' className='white-border'>
          {cafhistory.createdBy}
        </Col>
        {validitySetter(cafhistory.isValid)}
      </Row>
    </div>
  );
};

export default CafListRow;
